import React from 'react';
import { get as getProjection, transform } from 'ol/proj.js';
import View from 'ol/View';
import OlMap from 'ol/Map';
import { defaults as DefaultControl } from 'ol/control';
import { defaults as DefaultInteraction } from 'ol/interaction';
import {
  Vector as VectorSource,
} from 'ol/source';
import {
  Vector as VectorLayer,
} from 'ol/layer';
import { Style, Text, Icon, Fill } from 'ol/style';

import Overlay from 'ol/Overlay';
import olms from 'ol-mapbox-style';
import BUILDING_ICON from '../../../../assets/images/desktop/common/building.png'
import 'ol/ol.css';

export class MapDetail extends React.Component {
  constructor(props) {
    super();
    this.data = props.data
  }
  componentDidMount() {
    const controls = DefaultControl({
      attribution: false,
      rotate: false,
      zoom: false
    });

    this.map = new OlMap({
      target: 'mapDetail',
      view: new View({
        center: [12099282.16724, 4099021.83851],
        projection: getProjection('EPSG:3857'),
        zoom: 18,
        maxZoom: 20,
        minZoom: 4
      }),
      controls: controls,
      interactions: DefaultInteraction({
        mouseWheelZoom: true
      })
    });
    olms(this.map, `${window.location.origin}/data/ditu.json`);
    this.renderPoints()
  }

  renderPoints() {
    let points = this.data
    if (!Array.isArray(points) || !points.length > 0) return;

    let labelPositioning = 'center-bottom';
    let offset = [0, 0];
    let firstPos = null
    points.forEach((p, idx) => {
      const geo = this.posFromGeoPoint(p.geo);
      if (idx === 0) firstPos = geo;
      // const name = p.instanceName;
      const id = p.instanceId;
      const element = document.createElement('div');
      element.innerHTML = `
          <div class="mapPlaceOverlay">
            <div class="mapPlaceIcon">
              <img src="${BUILDING_ICON}" alt="" />
            </div>
          </div>
      `;
      // 2021/12/8 先不显示实例名称
      // <div class="mapPlaceLabel">
      //     ${name || ''}
      // </div>
      const overlay = new Overlay({
        id: `place-overlay-${id}`,
        offset: offset,
        element: element,
        stopEvent: false,
      });
      this.map.addOverlay(overlay);
      overlay.setPosition(geo);
      // 加载后设置位置，解决设置为center拖拽时会突变
      overlay.setPositioning(labelPositioning);
    })
    // 默认定位到第一个坐标点
    this.map.getView().setCenter(firstPos)
  }



  initPointLayer() {
    this.labelLayer = new VectorLayer({
      source: new VectorSource(),
      //   declutter: true,
      //   zIndex: 100,
      style: f => {
        const name = f.get('name');
        const imgSrc = BUILDING_ICON
        const iconStyle = new Style({
          image: new Icon({
            src: imgSrc,
            scale: 1,
            anchor: [0.5, 1],
          }),
        });
        const textStyle1 = new Style({
          text: new Text({
            font: '12px Microsoft YaHei',
            text: name,
            offsetX: 0,
            offsetY: -40,
            // 纵向排版
            // rotation: Math.PI / 2,
            fill: new Fill({ color: 'red' }),
          }),
        });
        return [iconStyle, textStyle1];
      },
    });
    this.map.addLayer(this.labelLayer);
  }

  /**
   * @description 字符串转换成坐标点
   * @param {String} geo "GEO(xxx, xxx)"类型的字符串
   * @returns {Array} 坐标点
   */
  posFromGeoPoint(geo) {
    const startIdx = geo.indexOf('(') + 1;
    const endIdx = geo.indexOf(')');
    const posStr = geo.substring(startIdx, endIdx);
    const pos = posStr.split(' ').map((s) => parseFloat(s));
    return transform(pos, 'EPSG:4326', 'EPSG:3857')
  }

  render() {
    return <div id="mapDetail" />
  }
}
